<app-map
  #mapComponent
  class="full-screen-map"
  [id]="data.id"
  [markers]="data.markers$ | async"
  [showRouteMarkers]="!!data.showRouteMarkers"
  [isFullScreenModal]="true"
  [customTemplate]="data.customTemplate"
  [autoZoomFit$]="data.autoZoomFit$"
  [addNewMarkerOnDblClick]="data.addNewMarkerOnDblClick"
  [newMarkerIconConfig]="data.newMarkerIconConfig"
  [markerUpdateTrigger$]="data.markerUpdateTrigger$"
  [center]="data.center"
  [zoom]="data.zoom"
  [enableShapeDrawing]="!!data.enableShapeDrawing"
  [shapes$]="data.shapes$"
  [deleteShapeTrigger$]="data.deleteShapeTrigger$"
  [shapeRightClickTrigger$]="data.shapeRightClickTrigger$"
  [shapeDrawTrigger$]="data.shapeDrawTrigger$"
  [useMarkerClustering]="data.useMarkerClustering"
  [toggleMarkerClustering$]="data.toggleMarkerClustering$"
  [enableTripImport]="data.enableTripImport"
  [mapRefreshFn]="data.mapRefreshFn"
  [enablePolylineAdd]="data.enablePolylineAdd"
  (closeFullScreen)="close($event)"></app-map>
